export default __webpack_public_path__ + "static/why-revenuecat-5e1619628980819764cab652de2fafaf.png";